import { createAction, props } from '@ngrx/store';
import { Agent } from 'src/app/client/agent-client';

export enum AgentTypes {
  add = 'agent/add',
  clean = 'agent/clean',
}

export const add = createAction(AgentTypes.add, props<{ agent: Agent }>());

export const clean = createAction(AgentTypes.clean);
